<template>
        <ul>
            <li @click="selectOption(optionValue.id)" :class="{
                'bg-amber-300 hover:border-black': selected === optionValue.id && optionValue.available,
                'border-black': selected === optionValue.id && !optionValue.available,
                'border-accent': selected !== optionValue.id && optionValue.available,
                '': selected !== optionValue.id && !optionValue.available,
                'hover:bg-amber-300 hover:border-black cursor-pointer': optionValue.available,
                'line-through border-muted text-muted hover:border-black cursor-default': !optionValue.available
            }" v-for="optionValue in options" :key="optionValue.id" class="inline-block mr-2 px-3 py-1 border rounded">
                {{ optionValue.name }}
            </li>
        </ul>
</template>
<script setup lang="ts">
import type { ProductOptionValueWithAvailability } from '~/types';

const {
    options,
    selected,
} = defineProps<{
  options: ProductOptionValueWithAvailability[],
  selected?: number
}>()

const emit = defineEmits<{
  (e: 'selectOption', optionValueId: number): void
}>()

function selectOption(valueId: number) {
    emit('selectOption', valueId)
}
</script>